/*
 * Copyright 2025 coze-dev Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * 当前模式下已选应用是否不在过滤后的应用列表中。
 * 本体数仓：列表只含已发布数仓映射的应用。
 * 本体模型：列表排除已发布数仓映射的应用。
 * 仅在列表加载完成后判定；未选择应用（空）由既有必填逻辑处理，这里不算无效。
 */
export function isSrMappingSelectionInvalid({
  requireSrMapping,
  excludeSrMapping,
  loading,
  apps,
  appId,
}: {
  requireSrMapping?: boolean;
  excludeSrMapping?: boolean;
  loading?: boolean;
  /** 已按当前模式过滤后的应用列表 */
  apps: { app_id: string }[];
  appId?: string;
}): boolean {
  if ((!requireSrMapping && !excludeSrMapping) || loading || !appId) {
    return false;
  }
  return !apps.some(app => app.app_id === appId);
}
